
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import venta_cliente from './estadisticas-clientes-venta-cliente.vue';
    import buscador from './estadisticas-clientes-buscador.vue';
    import { Cliente, EstadisticaVentas } from '@/__env/lib/Clientes';
import moment from 'moment';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            buscador,
            venta_cliente,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public Estado: string = 'cargando';
        public CargandoMas: boolean = false;

        public Buscando: boolean = false;
        public Items: EstadisticaVentas[] = [];

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            let e = await EstadisticaVentas.actuales( { page: this.Pagina } );
            this.Items = e.Items;
            this.Estado = 'ok';
        }


        protected Pagina = 1;
        async CargarMas()
        {
            this.CargandoMas = true;
            this.Pagina += 1;
            let e = await EstadisticaVentas.actuales( { page: this.Pagina } );
            this.Items.push( ...e.Items );
            this.CargandoMas = false;
        }


    }
